/*
    Server Side Events control messages processor
    Implements handlers for control messages (events) received from backend
    Calls one of registered handlers according the appropriate message type
 */

import {elog} from "@/engine/helpers/logging.js";
import {SSE} from "@/engine/comm/sse.js";

export const CM_TYPE_PROGRESS          = 1;
export const CM_TYPE_CLIENT_NOTICE     = 2;
export const CM_TYPE_LAYER_CREATED     = 3;
export const CM_TYPE_LAYER_DELETED     = 4;
export const CM_TYPE_WORKSPACE_CREATED = 5;
export const CM_TYPE_WORKSPACE_DELETED = 6;
export const CM_TYPE_WORKSPACE_UPDATE  = 7;
export const CM_TYPE_LAYER_UPDATE      = 8;
export const CM_SSE_EVENT_TYPE = "controlMessage";

export const CM_ERROR_FORMAT          = 10; //onboarding format error
export const CM_ERROR_DOWNLOAD        = 20; //onboarding download error

export const CN_TYPE_GEOMETRY_OP       = 1;

export const CN_GEOMETRY_OP_CREATE    = 1;
export const CN_GEOMETRY_OP_UPDATE    = 2;
export const CN_GEOMETRY_OP_DELETE    = 3;


//sse event struct
/*
type ControlMessage struct {
	Type		uint		`json:"type"`
	Uid			string		`json:"uid"`
	Payload		interface{}	`json:"payload"`
	WebPush		bool
}
 */

//Progress message struct
/*
type Task struct {
	UserId       string		`json:"userId"`
	TaskId       string		`json:"taskId"`
	Operation    string		`json:"operation"`
	Progress     int		`json:"progress"`
	Done         bool		`json:"done"`
	Success      bool		`json:"success"`
	ErrorCode    int		`json:"errorCode"`
	ErrorMessage string		`json:"errorMessage"`
	Data         interface{}`json:"data"`
}

type ClientNoticeOriginator struct {
	Id			string      `json:"id,omitempty"`
	Name        string      `json:"name"`
}

//client notice struct
type ClientNotice struct {
	Uid     	string      `json:"uid"`
	ClientNoticeOriginator  string      `json:"originator,omitempty"`
	Type        NoticeType  `json:"type"`
	Payload     interface{} `json:"payload"`
}

type ClientNoticeGeometry struct {
	WorkspaceId string      			`json:"workspaceId"`
	Operation   NoticeGeometryOperation `json:"operation"`
	Type        string                  `json:"type"` //geometry type
	Items       []string    			`json:"items"`
}

 */

export class sseCM {
    constructor(uri) {
        this.uri = uri;
        this.messageTypes = new Map()

        this.sse = new SSE(this.uri, {[CM_SSE_EVENT_TYPE]: function (event) {
                if (event && event.data) {
                    this._processMessage(JSON.parse(event.data));
                } else {
                    elog("Wrong event was received from stream")
                }
            }.bind(this)}, CM_SSE_EVENT_TYPE)

    }

    _processMessage(msg) {
        if (!msg || !msg.type) {
            elog("WARN", "Wrong remote command");
            return
        }
        elog("DEBUG", `Remote command ${msg.uid} has been received with type ${msg.type}`);
        let handler = this.messageTypes.get(msg.type)
        if (! handler) {
            elog("WARN", `No handler for remote command of type ${msg.type}`);
            return
        }
        handler(msg)
    }

    registerMessageHanlder(type, handler) {
        if ( typeof type == 'number' || typeof type == 'string' ) {
            type = [type]
        }
        for (let i in type) {
            if (this.messageTypes.has(type[i])) {
                elog("ERROR", "message handler already registered for type " + type[i])
            } else {
                this.messageTypes.set(type[i], handler)
            }
        }
    }

    isAlive() {
        return this.sse.isAlive();
    }

}
